// extracted by mini-css-extract-plugin
export default {"bodyContainer":"main_bodyContainer__c0h02"};